// extracted by mini-css-extract-plugin
export var o_headboard_aniversario = "headboardAniversario-module--o_headboard_aniversario--64736";
export var o_headboard_aniversario__bg = "headboardAniversario-module--o_headboard_aniversario__bg--abedc";
export var o_headboard_aniversario__ribbon = "headboardAniversario-module--o_headboard_aniversario__ribbon--5d9d3";
export var o_headboard_aniversario__video = "headboardAniversario-module--o_headboard_aniversario__video--55a79";